 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import COVER from '@/components/cover'
 import TOC from '@/components/toc'
 import A_CHAPTER401HQNETHERPALACE from '@/components/0_chapter401hqnetherpalace'
 import A_CHAPTER402COOPERATION from '@/components/1_chapter402cooperation'
 import A_CHAPTER403THISISTHESECONDTIME from '@/components/2_chapter403thisisthesecondtime'
 import A_CHAPTER404MOYUNFEISPROBING from '@/components/3_chapter404moyunfeisprobing'
 import A_CHAPTER405REMOVINGCHAINLINKRING from '@/components/4_chapter405removingchainlinkring'
 import A_CHAPTER406GENERALHEALTH from '@/components/5_chapter406generalhealth'
 import A_CHAPTER407THEFANATIC from '@/components/6_chapter407thefanatic'
 import A_CHAPTER408UNFATHOMABLETHOUGHTS from '@/components/7_chapter408unfathomablethoughts'
 import A_CHAPTER409INITIATIONOFTREATMENT from '@/components/8_chapter409initiationoftreatment'
 import A_CHAPTER410ENDOFFIRSTDIAGNOSIS from '@/components/9_chapter410endoffirstdiagnosis'
 import A0_CHAPTER411ITWASYOUWHOKILLEDHIM from '@/components/10_chapter411itwasyouwhokilledhim'
 import A1_CHAPTER412KILL from '@/components/11_chapter412kill'
 import A2_CHAPTER413WHY from '@/components/12_chapter413why'
 import A3_CHAPTER414WHYDIDISAVEHIM from '@/components/13_chapter414whydidisavehim'
 import A4_CHAPTER415DIAGNOSISANDTREATMENTOFDANTIAN from '@/components/14_chapter415diagnosisandtreatmentofdantian'
 import A5_CHAPTER416FOLLOWUPARRANGEMENTS from '@/components/15_chapter416followuparrangements'
 import A6_CHAPTER417ARRIVALINYOUZHOU from '@/components/16_chapter417arrivalinyouzhou'
 import A7_CHAPTER418HEMODERM from '@/components/17_chapter418hemoderm'
 import A8_CHAPTER419ICANHELPYOU from '@/components/18_chapter419icanhelpyou'
 import A9_CHAPTER420BLOODBATH from '@/components/19_chapter420bloodbath'
 import A0_CHAPTER421YOUARETHEINKEDGE from '@/components/20_chapter421youaretheinkedge'
 import A1_CHAPTER422BEAFRIEND from '@/components/21_chapter422beafriend'
 import A2_CHAPTER423ZONULARMARGIN from '@/components/22_chapter423zonularmargin'
 import A3_CHAPTER424BACKTOTHENETHERPALACE from '@/components/23_chapter424backtothenetherpalace'
 import A4_CHAPTER425IMBACK from '@/components/24_chapter425imback'
 import A5_CHAPTER426LETSBEGIN from '@/components/25_chapter426letsbegin'
 import A6_CHAPTER427ANSWERQUESTIONS from '@/components/26_chapter427answerquestions'
 import A7_CHAPTER428LETMEGO from '@/components/27_chapter428letmego'
 import A8_CHAPTER429DONTBEAFRAIDIMHERE from '@/components/28_chapter429dontbeafraidimhere'
 import A9_CHAPTER430DEFICIENCYOFBLOODSTAGNATIONOFQI from '@/components/29_chapter430deficiencyofbloodstagnationofqi'
 import A0_CHAPTER431LARGEDOG from '@/components/30_chapter431largedog'
 import A1_CHAPTER432THEREMUSTBEPITYINTHEHATEDONE from '@/components/31_chapter432theremustbepityinthehatedone'
 import A2_CHAPTER433BACKTOBEIJING from '@/components/32_chapter433backtobeijing'
 import A3_CHAPTER434FINALOBSERVATIONOFSPHENOIDOSIS from '@/components/33_chapter434finalobservationofsphenoidosis'
 import A4_CHAPTER435THECURRENTSITUATIONINBEIJING from '@/components/34_chapter435thecurrentsituationinbeijing'
 import A5_CHAPTER436HATEFULKINGBLIZZARD from '@/components/35_chapter436hatefulkingblizzard'
 import A6_CHAPTER437ADMISSIONTOTHEPALACE from '@/components/36_chapter437admissiontothepalace'
 import A7_CHAPTER438ENTERTHEPALACE from '@/components/37_chapter438enterthepalace'
 import A8_CHAPTER439CURRENTSITUATIONINTHEPALACE from '@/components/38_chapter439currentsituationinthepalace'
 import A9_CHAPTER440UNEXPECTEDDISCOVERY from '@/components/39_chapter440unexpecteddiscovery'
 import A0_CHAPTER441MOTHERANDCHILDCONVERSATION from '@/components/40_chapter441motherandchildconversation'
 import A1_CHAPTER442DARKAID from '@/components/41_chapter442darkaid'
 import A2_CHAPTER443TIMELYRAIN from '@/components/42_chapter443timelyrain'
 import A3_CHAPTER444CONFIRMCORRECT from '@/components/43_chapter444confirmcorrect'
 import A4_CHAPTER445FINALLYSEEHERMAJESTY from '@/components/44_chapter445finallyseehermajesty'
 import A5_CHAPTER446ANGERANDJOY from '@/components/45_chapter446angerandjoy'
 import A6_CHAPTER447CONFUSEDMOYUNFEI from '@/components/46_chapter447confusedmoyunfei'
 import A7_CHAPTER448THETWOOFTHEMFINALLYMET from '@/components/47_chapter448thetwoofthemfinallymet'
 import A8_CHAPTER449IMISSYOU from '@/components/48_chapter449imissyou'
 import A9_CHAPTER450INJURY from '@/components/49_chapter450injury'
 import A0_CHAPTER451PLEASEBELIEVEME from '@/components/50_chapter451pleasebelieveme'
 import A1_CHAPTER452IILNEVERHURTYOUAGAIN from '@/components/51_chapter452iilneverhurtyouagain'
 import A2_CHAPTER453START from '@/components/52_chapter453start'
 import A3_CHAPTER454DISSIMILARHARMONY from '@/components/53_chapter454dissimilarharmony'
 import A4_CHAPTER455GOODNEWSBADNEWS from '@/components/54_chapter455goodnewsbadnews'
 import A5_CHAPTER456SPECIALMEANS from '@/components/55_chapter456specialmeans'
 import A6_CHAPTER457SKITTISHDAILYLIFE from '@/components/56_chapter457skittishdailylife'
 import A7_CHAPTER458UNEXPECTEDVISITOR from '@/components/57_chapter458unexpectedvisitor'
 import A8_CHAPTER459IMGOINGTOSEESOMEOFTHEBESTTHINGSINTHEWORLD from '@/components/58_chapter459imgoingtoseesomeofthebestthingsintheworld'
 import A9_CHAPTER460INTELLIGENCEANALYSIS from '@/components/59_chapter460intelligenceanalysis'
 import A0_CHAPTER461MIDDLEREALITY from '@/components/60_chapter461middlereality'
 import A1_CHAPTER462POWERACQUISITION from '@/components/61_chapter462poweracquisition'
 import A2_CHAPTER463THESITUATIONISONESIDED from '@/components/62_chapter463thesituationisonesided'
 import A3_CHAPTER464DEMONICHEIGHTOFONEZHANG from '@/components/63_chapter464demonicheightofonezhang'
 import A4_CHAPTER465ADEEPTALKBETWEENMOTHERANDCHILD from '@/components/64_chapter465adeeptalkbetweenmotherandchild'
 import A5_CHAPTER466MISSEDOPPORTUNITIES from '@/components/65_chapter466missedopportunities'
 import A6_CHAPTER467IDONTLIKEYOUANYMORE from '@/components/66_chapter467idontlikeyouanymore'
 import A7_CHAPTER468LATESTARRANGEMENT from '@/components/67_chapter468latestarrangement'
 import A8_CHAPTER469DARKAGED from '@/components/68_chapter469darkaged'
 import A9_CHAPTER470ABRUPTMUTATION from '@/components/69_chapter470abruptmutation'
 import A0_CHAPTER471SLOWLYCOMB from '@/components/70_chapter471slowlycomb'
 import A1_CHAPTER472CLARIFY from '@/components/71_chapter472clarify'
 import A2_CHAPTER473GOODPROGRESS from '@/components/72_chapter473goodprogress'
 import A3_CHAPTER474TWOTUBESDOWN from '@/components/73_chapter474twotubesdown'
 import A4_CHAPTER475PREPARATIONS from '@/components/74_chapter475preparations'
 import A5_CHAPTER476SEEKER from '@/components/75_chapter476seeker'
 import A6_CHAPTER477WANGCHUAN from '@/components/76_chapter477wangchuan'
 import A7_CHAPTER478THEREISASPY from '@/components/77_chapter478thereisaspy'
 import A8_CHAPTER479VISITTOMOYUNLONG from '@/components/78_chapter479visittomoyunlong'
 import A9_CHAPTER480CONFIRMED from '@/components/79_chapter480confirmed'
 import A0_CHAPTER481FALSELYTRUE from '@/components/80_chapter481falselytrue'
 import A1_CHAPTER482QINGYANGINN from '@/components/81_chapter482qingyanginn'
 import A2_CHAPTER483INTRASTOREFORM from '@/components/82_chapter483intrastoreform'
 import A3_CHAPTER484LIDAIPEACHSTIFF from '@/components/83_chapter484lidaipeachstiff'
 import A4_CHAPTER485FOURPEOPLEFORALONGTALK from '@/components/84_chapter485fourpeopleforalongtalk'
 import A5_CHAPTER486ACCEPTED from '@/components/85_chapter486accepted'
 import A6_CHAPTER487XIONGNU from '@/components/86_chapter487xiongnu'
 import A7_CHAPTER488HERMAJESTYREVEALEDHERCARDS from '@/components/87_chapter488hermajestyrevealedhercards'
 import A8_CHAPTER489PROBINGINTOZHOUZHENG from '@/components/88_chapter489probingintozhouzheng'
 import A9_CHAPTER490PUSHTHEWAVESFORWARD from '@/components/89_chapter490pushthewavesforward'
 import A0_CHAPTER491IDENTIFY from '@/components/90_chapter491identify'
 import A1_CHAPTER492BROTHERLYMEETING from '@/components/91_chapter492brotherlymeeting'
 import A2_CHAPTER493PREPAREFORWAR from '@/components/92_chapter493prepareforwar'
 import A3_CHAPTER494KNOWINGFORALONGTIME from '@/components/93_chapter494knowingforalongtime'
 import A4_CHAPTER495ARAREWARMTH from '@/components/94_chapter495ararewarmth'
 import A5_CHAPTER496FEIERTAKECAREOFYOURSELF from '@/components/95_chapter496feiertakecareofyourself'
 import A6_CHAPTER497AUNTLIANGWEFINALLYMEETAGAIN from '@/components/96_chapter497auntliangwefinallymeetagain'
 import A7_CHAPTER498DEFEATISSETTLED from '@/components/97_chapter498defeatissettled'
 import A8_CHAPTER499FINALEXECUTION from '@/components/98_chapter499finalexecution'
 import A9_CHAPTER500QIYANDYSTOCIA from '@/components/99_chapter500qiyandystocia'
 import A00_CHAPTER501OUTBREAK from '@/components/100_chapter501outbreak'
 import A01_CHAPTER502YOUMAYGO from '@/components/101_chapter502youmaygo'
 import A02_CHAPTER503MOYUNLONGSANSWER from '@/components/102_chapter503moyunlongsanswer'
 import A03_CHAPTER504IMLEAVING from '@/components/103_chapter504imleaving'
 import A04_CHAPTER505CORTISOL from '@/components/104_chapter505cortisol'
 import A05_CHAPTER506PRODUCTIONOFAGUDISPELLINGFURNACE from '@/components/105_chapter506productionofagudispellingfurnace'
 import A06_CHAPTER507NANGONGIDEA from '@/components/106_chapter507nangongidea'
 import A07_CHAPTER508IFYOUDARETOTOUCHHIMTRYIT from '@/components/107_chapter508ifyoudaretotouchhimtryit'
 import A08_CHAPTER509PARAPHRENIA from '@/components/108_chapter509paraphrenia'
 import A09_CHAPTER510SWEETPUNISHMENT from '@/components/109_chapter510sweetpunishment'
 import A10_CHAPTER511LETSGETMARRIED from '@/components/110_chapter511letsgetmarried'
 import A11_CHAPTER512DETOXIFICATION from '@/components/111_chapter512detoxification'
 import A12_CHAPTER513ANTECEDENT from '@/components/112_chapter513antecedent'
 import A13_CHAPTER514WHATTODOWITHIT from '@/components/113_chapter514whattodowithit'
 import A14_CHAPTER515FIVETHINGS from '@/components/114_chapter515fivethings'
 import A15_CHAPTER516PREPARINGFORWEDDING from '@/components/115_chapter516preparingforwedding'
 import A16_CHAPTER517TRYONAWEDDINGDRESS from '@/components/116_chapter517tryonaweddingdress'
 import A17_CHAPTER518MARRIEDDAY from '@/components/117_chapter518marriedday'
 import A18_CHAPTER519AGIFTOFHOWTOACTTOGETHER from '@/components/118_chapter519agiftofhowtoacttogether'
 import A19_CHAPTER520CUPIDCANDLE from '@/components/119_chapter520cupidcandle'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/cover",
 			"name" : "cover",
 			"component" : COVER
 		},
 		{
 			"path" : "/toc",
 			"name" : "toc",
 			"component" : TOC
 		},
 		{
 			"path" : "/0_chapter401hqnetherpalace",
 			"name" : "0_chapter401hqnetherpalace",
 			"component" : A_CHAPTER401HQNETHERPALACE
 		},
 		{
 			"path" : "/1_chapter402cooperation",
 			"name" : "1_chapter402cooperation",
 			"component" : A_CHAPTER402COOPERATION
 		},
 		{
 			"path" : "/2_chapter403thisisthesecondtime",
 			"name" : "2_chapter403thisisthesecondtime",
 			"component" : A_CHAPTER403THISISTHESECONDTIME
 		},
 		{
 			"path" : "/3_chapter404moyunfeisprobing",
 			"name" : "3_chapter404moyunfeisprobing",
 			"component" : A_CHAPTER404MOYUNFEISPROBING
 		},
 		{
 			"path" : "/4_chapter405removingchainlinkring",
 			"name" : "4_chapter405removingchainlinkring",
 			"component" : A_CHAPTER405REMOVINGCHAINLINKRING
 		},
 		{
 			"path" : "/5_chapter406generalhealth",
 			"name" : "5_chapter406generalhealth",
 			"component" : A_CHAPTER406GENERALHEALTH
 		},
 		{
 			"path" : "/6_chapter407thefanatic",
 			"name" : "6_chapter407thefanatic",
 			"component" : A_CHAPTER407THEFANATIC
 		},
 		{
 			"path" : "/7_chapter408unfathomablethoughts",
 			"name" : "7_chapter408unfathomablethoughts",
 			"component" : A_CHAPTER408UNFATHOMABLETHOUGHTS
 		},
 		{
 			"path" : "/8_chapter409initiationoftreatment",
 			"name" : "8_chapter409initiationoftreatment",
 			"component" : A_CHAPTER409INITIATIONOFTREATMENT
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js